var etLoginDomain = process.env.REACT_APP_ET_LOGIN_PORTAL || 'https://auth.dev.evertransit.com';
var redirectTo = "".concat(etLoginDomain, "?redirectTo=").concat(window.location.href);

var getAuthPortalRedirectUrl = function getAuthPortalRedirectUrl() {
  return redirectTo;
};

export default getAuthPortalRedirectUrl;